import React, { Component } from 'react';
import { Button, Row, Col, Form, Tabs, Tab } from 'react-bootstrap';
import { Formik } from 'formik';
import moment from 'moment';
import DateRangePicker from 'react-bootstrap-daterangepicker';

import Layout from './DashboardLayout';
import Loading from '../components/Loader';
import { TeamMembersDropdown } from '../components/common';
import { teamService, timesheetService } from '../services';
import {
  ApproveTimesheetContent,
  ApproveTimeCardContent,
} from '../components/timesheet';

class TimesheetApproval extends Component {
  state = {
    isLoading: false,
    isUpdatingTeamsList: false,
    teamMembersList: [],
    timesheetDetails: [],
    timecardDetails: [],
    startDate: moment().startOf('week'),
    endDate: moment().endOf('week'),
  };

  pageHeading = {
    preTitle: 'Timesheet',
    title: 'Approval',
  };

  componentDidMount() {
    this.getTeamsData();
    this.getTimesheetApprovalData();
  }

  getTimesheetApprovalData = (formData) => {
    this.setState((state) => ({
      ...state,
      isLoading: true,
    }));
    const { startDate, endDate } = this.state;
    const dataFromDate = moment(startDate).format('YYYY-MM-DD');
    const dataToDate = moment(endDate).format('YYYY-MM-DD');
    const teamOwnerId = localStorage.getItem('teamOwnerId');

    const params = {
      teamOwnerId,
      teamMember: formData?.teamMember ? [formData.teamMember].flat() : 'all',
      fromDate: dataFromDate.concat(' 00:00:00'),
      toDate: dataToDate.concat(' 23:59:59'),
    };

    if (
      (formData && formData.teamMember === 'all') ||
      params.teamMember === 'all'
    ) {
      delete params.teamMember;
    }

    Promise.all([
      timesheetService.approvals_timesheet({
        ...params,
        groupBy: 'project',
      }),
      timesheetService.approvals_timesheet({
        ...params,
        groupBy: 'date',
      }),
    ])
      .then((results) => {
        const [timesheetView, timecardView] = results;
        this.setState((state) => ({
          ...state,
          isLoading: false,
          timesheetDetails: [...timesheetView.data.timesheetDetails],
          timecardDetails: [...timecardView.data.timesheetDetails],
        }));
      })
      .catch(() => {
        this.setState((state) => ({
          ...state,
          isLoading: false,
        }));
      });
  };

  handleDateSelect = (event, picker) => {
    picker.element.val(
      `${moment(picker.startDate).day(0).format('MMM D, YYYY')} - ${moment(
        picker.endDate
      )
        .day(6)
        .format('MMM D, YYYY')}`
    );
    this.setState((state) => ({
      ...state,
      startDate: moment(picker.startDate).day(0),
      endDate: moment(picker.endDate).day(6),
    }));
  };

  getTeamsData = () => {
    this.setState((state) => ({
      ...state,
      isUpdatingTeamsList: true,
    }));
    teamService
      .get_team_members_data({
        teamOwnerId: localStorage.getItem('teamOwnerId'),
        summaryList: true,
      })
      .then((response) => {
        const { members } = response.data;
        this.setState((state) => ({
          ...state,
          teamMembersList: [...members],
          isUpdatingTeamsList: false,
        }));
      })
      .catch(() => {
        this.setState((state) => ({
          ...state,
          isUpdatingTeamsList: false,
        }));
      });
  };

  handleWeeklyStatusUpdate = (data) => {
    const teamOwnerId = localStorage.getItem('teamOwnerId');
    this.setState((state) => ({
      ...state,
      isLoading: true,
    }));

    timesheetService
      .status_update({
        teamOwnerId,
        weeklySubmissionId: data.weeklySubmissionId,
        teamMemberId: data.teamMember,
        status: data.status,
        note: data.note,
      })
      .then((result) => {
        if (result.status) {
          this.getTimesheetApprovalData();
        }
      })
      .catch(() => {
        this.setState((state) => ({
          ...state,
          isLoading: false,
        }));
      });
  };

  render() {
    const {
      isLoading,
      teamMembersList,
      isUpdatingTeamsList,
      timesheetDetails,
      timecardDetails,
      startDate,
      endDate,
    } = this.state;

    return (
      <Layout pageHeading={this.pageHeading}>
        <Formik
          initialValues={{
            teamMember: 'all',
            fromDate: startDate,
            toDate: endDate,
          }}
          onSubmit={(values) => {
            this.getTimesheetApprovalData(values);
          }}
        >
          {(formikprops) => (
            <Form onSubmit={formikprops.handleSubmit}>
              <Row>
                <Col md={4} lg={3}>
                  <TeamMembersDropdown
                    teamMembersList={teamMembersList}
                    isUpdatingTeamsList={isUpdatingTeamsList}
                    isAllOptionRequired
                  />
                </Col>
                <Col md={4} lg={3}>
                  <Form.Group>
                    <Form.Label>Date range</Form.Label>
                    <div id="week-picker-wrapper">
                      <DateRangePicker
                        onEvent={this.handleDateSelect}
                        initialSettings={{
                          autoUpdateInput: false,
                          singleDatePicker: true,
                          startDate: moment().toDate(),
                          locale: {
                            format: 'MMM D, YYYY',
                          },
                          alwaysShowCalendars: true,
                          autoApply: true,
                        }}
                      >
                        <input
                          type="text"
                          className="form-control icon-calendar"
                          placeholder={`${moment()
                            .day(0)
                            .format('MMM D, YYYY')} - ${moment()
                            .day(6)
                            .format('MMM D, YYYY')}`}
                        />
                      </DateRangePicker>
                    </div>
                  </Form.Group>
                </Col>
                <Col md={4} lg={3}>
                  <Form.Group controlId="generateData">
                    <Form.Label>&nbsp;</Form.Label>
                    <div>
                      <Button variant="primary" type="Submit">
                        Generate
                      </Button>
                    </div>
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>

        <Tabs
          defaultActiveKey="approve-timesheet"
          id="approve-tabs"
          className="mb-5"
        >
          <Tab eventKey="approve-timesheet" title="Timesheet">
            <ApproveTimesheetContent
              timesheetDetails={timesheetDetails}
              isLoading={isLoading}
              statusUpdate={this.handleWeeklyStatusUpdate}
            />
          </Tab>
          <Tab eventKey="approve-timecard" title="Timecard">
            <ApproveTimeCardContent
              timecardDetails={timecardDetails}
              isLoading={isLoading}
              statusUpdate={this.handleWeeklyStatusUpdate}
            />
          </Tab>
        </Tabs>

        {/* Loader */}
        {isLoading && <Loading contentAreaOnly />}
      </Layout>
    );
  }
}

export default TimesheetApproval;
